import { useEffect, useState } from "react";
import { useDebounceValue } from "../../hooks";
import { CustomInput } from "./CustomInput";
import { SearchIcon } from "../images/SearchIcon";

export const InputWithDebounce = ({
  value,
  setValue,
}: {
  value: string;
  setValue: (v: string) => void;
}) => {
  const [search, setSearch] = useState(value);
  const searchDebounce = useDebounceValue(search);

  useEffect(() => {
    setValue(searchDebounce);
  }, [searchDebounce]);

  return (
    <CustomInput
      value={search}
      placeholder="Search"
      prefixIcon={<SearchIcon />}
      onChange={setSearch}
      clearButton
    />
  );
};
